var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBadgesuccessshine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480,
    height: 480,
    viewBox: "0 0 480 480",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3234_7021)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-73 279.303L237.466 240.838L-50.6382 362.759L-11.4606 430.617L238.179 242.071L49.6337 491.711L117.491 530.888L239.412 242.786L200.947 553.25H279.302L240.837 242.783L362.759 530.888L430.616 491.711L242.072 242.072L491.71 430.617L530.888 362.759L242.783 240.838L553.25 279.303L553.25 200.948L242.784 239.413L530.888 117.491L491.71 49.6338L242.071 238.179L430.616 -11.4603L362.758 -50.6379L240.838 237.464L279.303 -73L200.948 -73L239.413 237.468L117.491 -50.638L49.6336 -11.4604L238.178 238.178L-11.4602 49.6337L-50.6378 117.491L237.467 239.413L-73 200.948L-73 279.303Z",
    fill: "url(#paint0_radial_3234_7021)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3234_7021",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(240.125 240.125) rotate(90) scale(313.125 313.125)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#FFC303",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#FFC303",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3234_7021"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 480,
    height: 480,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgesuccessshine);
export default __webpack_public_path__ + "static/media/badgesuccessshine.657b567885a12f079b0734cf93917e73.svg";
export { ForwardRef as ReactComponent };